export const SHOW_WARNING_NOTIFICATION = 'SHOW_WARNING_NOTIFICATION';

export const showWarningNotification = ( message ) => ({
    type: SHOW_WARNING_NOTIFICATION,
    payload: { message },
});
